import { IExaminationSettings } from 'shared/types'

export const defaultExaminationSettings: IExaminationSettings = {
  duration: 90 * 60 * 1000,
  attempts: 3,
  cooldown: 14 * 24 * 60 * 60 * 1000,
  messages: []
}
